import classes from "../homePageNew.module.css";
import { StackIcon } from "./icons";
import ReportRow from "./ReportRow";
import { reportTypeLabel } from "../api/homePageApi";

// Same slim bordered row ReportRow uses when a report exists — a message
// here shouldn't switch to a different, heavier empty-state box design.
function ReportMessageRow({ text }) {
  return (
    <div className={classes.reportRow} style={{ alignItems: "center", textAlign: "center", color: "var(--hpn-ink-3)" }}>
      {text}
    </div>
  );
}

/**
 * Reporting section for a selected record — driven entirely by the record's
 * own `report` object, no separate API call.
 *
 * `unavailable` (record.scores/report genuinely absent — a run still
 * processing, regardless of whether it came from search or the main list)
 * → distinct "not available yet" empty state.
 * report.totalCount === 0 (the common case in live data today) → explicit
 * "no report generated yet" empty state, never a blank section.
 *
 * "N more reports" opens ReportsModal, which fetches the real full list via
 * the html-history endpoint on demand — see ReportsModal.js. Both that modal
 * and this strip's own row share the same ReportRow (eye/open/download).
 */
export default function ReportStrip({ report, unavailable, onOpenReportsModal, onViewReport, showType = true, moduleKey }) {
  if (unavailable) {
    return (
      <div className={classes.reportStrip}>
        <div className={classes.reportStripHead}>
          <span className={classes.rh}>Reporting</span>
        </div>
        <ReportMessageRow text="Not available yet — this run hasn't finished processing." />
      </div>
    );
  }

  const totalCount = report?.totalCount || 0;
  const moreCount = totalCount - 1;
  const latest = report?.latest;

  return (
    <div className={classes.reportStrip}>
      <div className={classes.reportStripHead}>
        <span className={classes.rh}>Reporting</span>
      </div>
      {totalCount === 0 ? (
        <ReportMessageRow text="No report generated yet for this run" />
      ) : (
        <>
          <ReportRow
            jobId={latest?.id}
            status={latest?.status}
            type={reportTypeLabel(moduleKey, latest)}
            showType={showType}
            category={latest?.category}
            llms={latest?.llms}
            market={latest?.markets}
            persona={latest?.persona}
            date={latest?.startDate}
            onView={(jobId) => onViewReport({ jobId, category: latest?.category })}
          />
          {moreCount > 0 && (
            <button className={classes.moreReportsLink} onClick={onOpenReportsModal}>
              <StackIcon size={13} />
              {moreCount} more report{moreCount > 1 ? "s" : ""} for this run
            </button>
          )}
        </>
      )}
    </div>
  );
}
